import PageHeader from '../molecules/PageHeader';
import SectionBox from '../atoms/SectionBox';
import { TextField, MenuItem, Snackbar } from '@mui/material';
import FormSubmissionButtons from '../molecules/FormSubmissionButtons';

const AddParentLayout = ({ student, handleChange, handleFormSubmission }) => {
  return (
    <div>
      <PageHeader>New Parent</PageHeader>

      <SectionBox
        title={
          student
            ? `Parent of ${student.student_first_name} ${student.student_last_name}`
            : 'Loading...'
        }
      >
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          <div className='col-span-6 md:col-span-4'>
            <TextField
              label='Parent Name'
              fullWidth
              name='parent_name'
              onChange={handleChange}
              inputProps={{ 'data-cy': 'parent-name-field' }}
            />
          </div>

          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='Relationship'
              fullWidth
              name='parent_relationship'
              onChange={handleChange}
              inputProps={{ 'data-cy': 'parent-relationship-field' }}
            />
          </div>

          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='ID'
              fullWidth
              name='parent_identity_number'
              onChange={handleChange}
              inputProps={{ 'data-cy': 'parent-ID-field' }}
            />
          </div>

          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='Mobile'
              fullWidth
              name='parent_mobile'
              onChange={handleChange}
              inputProps={{ 'data-cy': 'parent-mobile-field' }}
            />
          </div>

          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='Email'
              fullWidth
              name='parent_email'
              onChange={handleChange}
              inputProps={{ 'data-cy': 'parent-email-field' }}
            />
          </div>

          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='Religion'
              fullWidth
              name='parent_religion'
              defaultValue='catholic'
              onChange={handleChange}
              inputProps={{ 'data-cy': 'parent-religion-field' }}
              select
              id='parent_religion'
            >
              <MenuItem value='catholic'>Catholic</MenuItem>
              <MenuItem value='non-catholic'>Non Catholic</MenuItem>
            </TextField>
          </div>
        </div>
      </SectionBox>

      <FormSubmissionButtons submissionHandler={handleFormSubmission} />
    </div>
  );
};

export default AddParentLayout;
